import React, { Component } from "react";
import "../Styles/SvgCommand.css";

const SelectedRowIcon = (props) => {
  return (
    <svg className="svgSelectedRow" width="8.000000pt" height="8.000000pt" viewBox="0 0 512.000000 512.000000" >

      <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" >
        <path d="M388 5103 c-57 -36 -53 135 -53 -2543 0 -2040 2 -2481 13 -2502 17 -31 62 -58 99 -58 36 0 4295 2464 4319 2499 21 30 21 90 1 122 -24 36 -4271 2493 -4317 2496 -20 2 -46 -4 -62 -14z"/>
      </g>
    </svg>
    
  );
};

export default SelectedRowIcon;
